export default function MastheadSection() {
  return (
    <section className="relative w-full" style={{ minHeight: '520px' }}>
      <div
        className="w-full flex items-start"
        style={{
          background: 'linear-gradient(135deg, oklch(0.98 0.005 85) 0%, oklch(0.94 0.004 90) 50%, oklch(0.91 0.003 95) 100%)',
          minHeight: '520px',
        }}
      >
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-24 md:pt-32 pb-36 md:pb-40">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
            <div className="lg:w-[60%]">
              <h1 className="font-heading text-[2.8rem] md:text-[4.2rem] lg:text-[5.5rem] leading-[0.95] tracking-[-0.02em] text-foreground-950">
                AETERNA
                <br />
                SOFTWARE,
                <br />
                UAB
              </h1>
              <div className="mt-8 w-[40%] h-px bg-foreground-300/50" />
            </div>

            <div className="lg:w-[40%] lg:pt-2">
              <p className="font-body text-sm md:text-[15px] leading-relaxed text-foreground-600 max-w-[340px]">
                A professional engineering team focused on designing and developing modern digital
                software solutions for the iOS platform and related technologies. We build scalable,
                maintainable, and high-performance systems with a strong focus on usability,
                stability, and long-term technical quality.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}